import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { CONSENT_ACTION } from '@core/consent';
import { LogoComponent } from '@core/ui';
import { CrntButton } from '@essent/current-web-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-cookiewall',
  standalone: true,
  imports: [LogoComponent, CrntButton, AutomationIdDirective],
  templateUrl: './cookiewall.component.html',
  styleUrls: [
    './cookiewall.component.ed.scss',
    './cookiewall.component.essent.scss',
  ],
})
export class CookiewallComponent {
  modal = inject(NgbActiveModal);
  readonly #brand = inject(ENVIRONMENT_CONFIG).app.replace('mijn-', '');

  brandName = this.#brand[0].toUpperCase() + this.#brand.slice(1);

  accept() {
    this.modal.close(CONSENT_ACTION.ACCEPT);
  }

  reject() {
    this.modal.close(CONSENT_ACTION.REJECT);
  }
}
